import type { Messages } from '@wix/fe-essentials/i18n';

export interface WixPatternsInitialProps {
  messages?: Messages;
}
